import { PrismicNextImage } from '@prismicio/next';
import { asText, Content, isFilled } from '@prismicio/client';

import { Box, Typography } from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';
import { BaseProductsContainer } from '@/slices/shared/Products/BaseProductsContainer';

type WithDetailsSimpleProductsProps = {
  sliceId: string;
  slice: Content.ProductsSliceWithDetailsSimpleProducts;
};

export const WithDetailsSimpleProducts = ({
  slice,
  sliceId,
}: WithDetailsSimpleProductsProps) => {
  const { primary } = slice;
  const {
    products,
    details_image,
    details_caption,
    details_lede_text,
    display_product_images,
  } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <>
      <Box
        addSwitcher
        gap="gap-lg"
        component="div"
        style={{ ['--c6-switcher-vertical-alignment' as string]: 'center' }}
      >
        <Box component="div" addFlow>
          <Typography component="p" className="lede">
            {asText(details_lede_text)}
          </Typography>

          <RichText
            variant="default"
            content={details_caption}
            websiteUrl={WebsiteUrl}
          />
        </Box>

        <figure className="feature-img">
          {isFilled.image(details_image) && (
            <PrismicNextImage field={details_image} />
          )}
        </figure>
      </Box>

      <BaseProductsContainer
        addRegion
        sliceId={sliceId}
        products={products}
        displayImage={display_product_images}
      />
    </>
  );
};
